import type { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const FIELD_HEIGHT = '3.5rem';

export const usePhoneInputStyles = makeStyles(() => ({
  phoneNumberInput: {
    width: '100%',
    height: FIELD_HEIGHT,
    '&.react-tel-input': {
      '& .flag-dropdown': {
        borderRadius: '0.3125rem 0 0 0.3125rem',
      },
      '&  .form-control': {
        width: '100%',
        height: '100%',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '1rem',
        boxShadow: 'none',
        borderRadius: '0.3125rem',
      },
    },
  },
}));

export const useAsteriskStyles = makeStyles((theme: Theme) => ({
  requiredFieldAsterisk: {
    color: theme.palette.error.main,
  },
}));

export const useSelectStyles = makeStyles(() => ({
  selectFieldInput: {
    height: FIELD_HEIGHT,
    borderRadius: '0.3125rem',
    paddingLeft: 0,
    boxShadow: 'none',
    border: '1px solid #CACACA',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  autoCompleteField: {
    margin: 0,
  },
}));

export const styles = {
  submitButton: {
    margin: 'clamp(0.75rem, 5dvh, 1rem) auto 0',
    width: '100%',
  },

  pageContainer: {
    position: 'relative',
    width: '100%',
    minHeight: 'calc(100dvh - 2rem)',
    padding: '0 0',
    background: 'linear-gradient(135deg, #0a4d4d 0%, #083838 50%, #0a3d3d 100%)',
    overflow: 'hidden',
    backgroundImage: 'url(https://welligence.com/wp-content/uploads/2020/05/home-section1-bg.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },

  formWrapper: {
    position: 'relative',
    zIndex: 1,
    padding: '3dvh 0 1.5dvh',
    backgroundColor: 'background.paper',
  },

  loadingForm: {
    display: 'flex',
    justifyContent: 'center',
    width: 'clamp(10rem, 98%, 45rem)',
  },

  logo: {
    margin: '0',
    padding: '0',
    width: 'clamp(8rem, 90%, 10rem)',
    height: 'auto',
    gridColumn: '2/3',
  },

  formField: {
    position: 'relative',
    '& .MuiFormLabel-root': {
      top: '0.125rem',
      textTransform: 'uppercase',
      fontSize: '0.75rem',
    },
  },
  formFieldRow: {
    width: '100%',
  },

  textFieldInput: {
    '& .MuiFilledInput-root': {
      borderRadius: '0.3125rem',
      boxShadow: 'none',

      '&:before': {
        display: 'none',
      },
      '&:after': {
        display: 'none',
      },
      '&:hover': {
        backgroundColor: '#fafafa',
      },
      '&.Mui-focused': {
        backgroundColor: '#fafafa',
      },
    },
  },

  passwordRules: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.5,
    width: '100%',
    marginTop: 0.5,
  },

  passwordRuleBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.35,
    padding: '0.125rem 0.35rem 0.125rem 0.2rem',
    borderRadius: 1,
    transition: 'color 0.2s ease',
  },
};
